(function() { window.GUID_fd11a367_c812_43ae_8d76_a823e9e11e19 = { getGuid: function() { return "fd11a367-c812-43ae-8d76-a823e9e11e19"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class BracketHeader {
            constructor(bracket, sectionNumber) {
                let me = this;
                me.exist = false;
                me.sectionNumber = sectionNumber;
                this.bracket = bracket;
                this.$Header = this.bracket.$Control.find('.bracket__section-header.s-' + sectionNumber);
            }
        }
        Controls.BracketHeader = BracketHeader;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=bracket-header.js.map
